var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CampaignRounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.5 12.2533C18.5 12.8033 18.95 13.2533 19.5 13.2533H21.5C22.05 13.2533 22.5 12.8033 22.5 12.2533C22.5 11.7033 22.05 11.2533 21.5 11.2533H19.5C18.95 11.2533 18.5 11.7033 18.5 12.2533Z",
    fill: "url(#paint0_linear_14611_177398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.09 17.0733C16.76 17.5133 16.85 18.1233 17.29 18.4433C17.82 18.8333 18.38 19.2533 18.91 19.6533C19.35 19.9833 19.97 19.8933 20.29 19.4533C20.29 19.4433 20.3 19.4433 20.3 19.4333C20.63 18.9933 20.54 18.3733 20.1 18.0533C19.57 17.6533 19.01 17.2333 18.49 16.8433C18.05 16.5133 17.43 16.6133 17.1 17.0533C17.1 17.0633 17.09 17.0733 17.09 17.0733Z",
    fill: "url(#paint1_linear_14611_177398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.3101 5.06334C20.3101 5.05334 20.3001 5.05334 20.3001 5.04334C19.9701 4.60334 19.3501 4.51334 18.9201 4.84334C18.3901 5.24334 17.8201 5.66334 17.3001 6.06334C16.8601 6.39334 16.7801 7.01334 17.1101 7.44334C17.1101 7.45334 17.1201 7.45334 17.1201 7.46334C17.4501 7.90334 18.0601 7.99334 18.5001 7.66334C19.0301 7.27334 19.5901 6.84334 20.1201 6.44334C20.5501 6.12334 20.6301 5.50334 20.3101 5.06334Z",
    fill: "url(#paint2_linear_14611_177398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.5 9.2533H4.5C3.4 9.2533 2.5 10.1533 2.5 11.2533V13.2533C2.5 14.3533 3.4 15.2533 4.5 15.2533H5.5V18.2533C5.5 18.8033 5.95 19.2533 6.5 19.2533C7.05 19.2533 7.5 18.8033 7.5 18.2533V15.2533H8.5L13.5 18.2533V6.2533L8.5 9.2533Z",
    fill: "url(#paint3_linear_14611_177398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16 12.2533C16 10.9233 15.42 9.72332 14.5 8.90332V15.5933C15.42 14.7833 16 13.5833 16 12.2533Z",
    fill: "url(#paint4_linear_14611_177398)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14611_177398",
    x1: 18.5,
    y1: 11.2533,
    x2: 20.1,
    y2: 14.4533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0054EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0343B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14611_177398",
    x1: 16.8911,
    y1: 16.6479,
    x2: 20.073,
    y2: 20.2306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0054EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0343B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14611_177398",
    x1: 16.9075,
    y1: 4.64441,
    x2: 20.1054,
    y2: 8.22002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0054EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0343B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14611_177398",
    x1: 2.5,
    y1: 6.2533,
    x2: 15.3207,
    y2: 17.1016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0054EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0343B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14611_177398",
    x1: 14.5,
    y1: 8.90332,
    x2: 17.3564,
    y2: 9.54377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0054EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0343B7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.7e06a8e981d202a1f5bbeb8841dee72d.svg";
export { ForwardRef as ReactComponent };